// eslint-disable-next-line  no-unused-vars
import app from 'js/aofl-js/0.8.0/app/app';
import cookieService from 'readingiq-src/js/cookie-service/1.0.0/index';
import riqApiFormatter from 'readingiq-src/js/riq-js/riq-api-formatter/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-init-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-api-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-error-handler-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-group-model-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-invite-families-model-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-challenge-model-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-user-model-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-progress-bar/1.0.0/index';
import 'readingiq-src/js/riq-js/navigation-bar/1.0.0/index';
import 'readingiq-src/js/riq-js/aofl-list-option/1.0.0/index';
import 'readingiq-src/js/riq-js/aofl-panel/1.0.0/index';
import 'readingiq-src/js/riq-js/aofl-select-list/1.0.0/index';
import 'readingiq-src/js/riq-js/aofl-unique-id-service/1.0.0/index';
import 'readingiq-src/js/riq-js/info-message-modal/1.0.0/index';
import 'readingiq-src/js/riq-js/password-modal/1.0.0/index';
import 'readingiq-src/js/riq-js/access-control-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-user-state-service/1.0.0/index';
import 'readingiq-src/js/riq-js/pagearea-state-service/1.0.0/index';
import 'readingiq-src/js/riq-js/pagearea-tracker-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-child-form/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-listener-set-previous-state-route/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-listener-invalidate-cache/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-preload-manager/1.0.0/index';
import 'readingiq-src/js/riq-js/marketing-popup-listener/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-dropdown/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-select-user/1.0.0/index';
import 'js/riq-ripple/1.0.0/index';
import 'js/toastr/toastr';
import 'js/riq-textfield/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-listener-hide-header/1.0.0/index';
import 'readingiq-src/js/riq-js/no-mouse-focus/1.0.0/index';
// import 'readingiq-src/teacher_dashboard_com_en/js/teacher-dashboard-container/index';

export default {
  riqApiFormatter: riqApiFormatter,
  cookieService: cookieService
};
